import { IFormField } from '@pra-vendas-themes/interfaces/IFormField';

import { useComponentsTheme } from 'hooks/useComponentsTheme';

import { WithChildren } from 'types/WithChildren';

export const FormField: WithChildren<IFormField> = ({ children, ...props }) => {
  const { FormField: FormFieldTheme } = useComponentsTheme();

  return <FormFieldTheme {...props}>{children}</FormFieldTheme>;
};
